

export const mapDocumentToArray = (document) => {
    if(document === null || typeof document === 'undefined' || document === "") return [];
    return document.split(',')
  };

 export const mapArrayToDocument = (documents) => {
      if(!documents && documents.length) return "";
      return documents.join(',');
  };

  export const addDocumentToArray = (previousDocument, document) => {
    if(previousDocument === null || typeof previousDocument === 'undefined' || previousDocument === "") return document;
    var commaSeperatedArray =   previousDocument.split(',')
    commaSeperatedArray.push(document);
    return commaSeperatedArray.join(',');
};

export const removeDocumentFromArray = (previousDocument, document) => {
    if(previousDocument === null || typeof previousDocument === 'undefined' || previousDocument === "") return "";
    var commaSeperatedArray =   previousDocument.split(',')
    var filtered =  commaSeperatedArray.filter(x=> x !== document);
    return filtered.join(',');
};

export const mapLibraryPrefix = (documentName) => {
    if(documentName !== null && typeof documentName !== 'undefined' && documentName.startsWith('branch')){
        return "https://hastrak.blob.core.windows.net/user-library/";
    }
    else{
        return "https://hastrak.blob.core.windows.net/library/";
    }
}


export const getFormattedDocumentName = (document) => {
    if(document === null || typeof document === 'undefined' || document === "") return "";
        let documentArray = document.split('/');
        if(documentArray && documentArray.length){
            return documentArray.length > 1 ? documentArray[documentArray.length-1] : document;
        }
        return document;  
}
  